import React, { Component, lazy, Suspense } from "react";
import { Container } from "reactstrap";
import {
  Route,
  Switch,
  BrowserRouter,
  HashRouter,
  Redirect
} from "react-router-dom";
import isElectron from "./utils/isElectron";

import { InterviewContextProvider } from "./InterviewContext";

import Loading from "./components/Loading";
import Navigation from "./components/Navigation";

const ActivityArea = lazy(() => import("./components/activities/ActivityArea"));
const ActivityReport = lazy(() =>
  import("./components/activities/ActivityReport")
);
const Contact = lazy(() => import("./components/contact/Contact"));
const Downloads = lazy(() => import("./components/downloads/Downloads"));
const FAQ = lazy(() => import("./components/faq/FAQ"));
const Footer = lazy(() => import("./components/Footer"));
const HelpArea = lazy(() => import("./components/help/HelpArea"));
const Home = lazy(() => import("./components/home/Home"));
const InterviewArea = lazy(() =>
  import("./components/interview/InterviewArea")
);
const InterviewInProgress = lazy(() =>
  import("./components/interview/InterviewInProgress")
);
const InterviewReport = lazy(() =>
  import("./components/interview/InterviewReport")
);
const Video = lazy(() => import("./components/video/Video"));

import "./App.css"; // eslint-disable-line import/first

function Router({ children }: React.Props<any>) {
  return isElectron() ? (
    <HashRouter>{children}</HashRouter>
  ) : (
    <BrowserRouter>{children}</BrowserRouter>
  );
}

class App extends Component {
  render() {
    return (
      <Router>
        <InterviewContextProvider>
          <div>
            <Navigation />
            <Suspense fallback={<Loading />}>
              <InterviewInProgress />
            </Suspense>
            <br />
            <Container fluid>
              <Suspense fallback={<Loading />}>
                <Switch>
                  <Route path="/" exact component={Home} />
                  {/* Redirect from the default Electron path*/}
                  <Route
                    path="/index.html"
                    exact
                    render={() => <Redirect to="/" />}
                  />
                  <Route path="/interview/report" component={InterviewReport} />
                  <Route path="/interview" component={InterviewArea} />
                  <Route path="/activities/report" component={ActivityReport} />
                  <Route path="/activities" component={ActivityArea} />
                  <Route path="/downloads" component={Downloads} />
                  <Route path="/faq" exact component={FAQ} />
                  <Route path="/help" component={HelpArea} />
                  <Route path="/contact" exact component={Contact} />
                  <Route path="/video" component={Video} />
                </Switch>
              </Suspense>
            </Container>
            <Suspense fallback={<Loading />}>
              <Footer />
            </Suspense>
          </div>
        </InterviewContextProvider>
      </Router>
    );
  }
}

export default App;
